import { axios } from 'Lib/axios'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const useUpdatePaymentMethod = () => {
  const queryClient = useQueryClient()
  return useMutation(updatePaymentMethod, {
    onSuccess: () => {
      void queryClient.invalidateQueries(['creditCard'])
      void queryClient.invalidateQueries(['getPlansDetails'])
    },
  })
}

const updatePaymentMethod = async (token: string) => {
  const accountId = useUserStore.getState().accountId

  try {
    await axios.put(`accounts/${accountId}/subscriptions/card`, { token })
  } catch (e) {
    return e as Error
  }
}
